<template>
    <v-container fluid fill-height>
        <Headful title="Profiel insturen"></Headful>
        <Header
            show-logo
            color="white"
            :dark="false"
            show-back-button
            extended
        ></Header>
        <v-layout align-center class="mt-5 mb-5">
            <v-flex>
                <v-form ref="form" @submit.prevent="submit" class="px-5" :disabled="loading || submitting || success">
                    <v-card class="elevation-0">
                        <v-card-text class="pa-7">
                            <h1 class="text-h5 mb-5 text-center text--success">Profiel insturen</h1>
                            <p class="text-center mb-5">Vul de onderstaande gegevens in om je profiel in te sturen.</p>
                            <div v-if="!success">
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Naam" v-model="profile.name" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Geboortedatum" v-model="profile.dateOfBirth" type="date" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Woonplaats" v-model="profile.city" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Telefoonnummer" v-model="profile.phoneNumber" type="tel" :rules="[requiredRule, phoneNumberRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="E-mailadres" v-model="profile.email" type="email" :rules="[requiredRule, emailRule]"
                                ></v-text-field>
                                <v-textarea outlined rounded required no-resize hide-details="auto" class="mb-4"
                                    label="Introductietekst" v-model="profile.introduction" :rules="[requiredRule]"
                                ></v-textarea>
                                <v-textarea outlined rounded required no-resize hide-details="auto" class="mb-4"
                                    label="Vaardigheden / kwaliteiten" v-model="profile.summary" :rules="[requiredRule]"
                                ></v-textarea>
                                <v-textarea outlined rounded no-resize hide-details="auto" class="mb-4"
                                    label="Opmerkingen" v-model="profile.remarks"
                                ></v-textarea>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="LinkedIn url" v-model="profile.linkedInUrl"
                                ></v-text-field>
                                <v-text-field outlined rounded class="mb-2" persistent-hint hide-details="auto" :rules="[videoUrlRule]"
                                    label="Video" v-model="profile.videoUrl" hint="Voer een geldige YouTube of Vimeo URL in."
                                ></v-text-field>
                                <v-file-input outlined rounded prepend-icon="fa-camera" hide-details="auto" class="mb-4"
                                    label="Profielfoto" v-model="profile.image" accept="image/*"
                                ></v-file-input>
                                <v-file-input outlined rounded prepend-icon="fa-paperclip" hide-details="auto" class="mb-4"
                                    label="Curriculum Vitae" v-model="profile.curriculumVitae"
                                ></v-file-input>
                                <v-select outlined rounded hide-details="auto" class="mb-4" multiple
                                    v-for="facet in facets" :key="facet.id" :required="facet.isRequired" :rules="facet.isRequired ? [notEmptyRule] : []"
                                    :items="facet.choices"
                                    v-model="profile.facetChoices['facet'+facet.id]"
                                    item-value="id"
                                    item-text="value"
                                    :label="facet.name"
                                ></v-select>
                                <v-checkbox hide-details="auto" class="mb-4"
                                    v-model="profile.consent"
                                    label="Ik geef toestemming voor opname van mijn persoonsgegevens"
                                    :rules="[consentRule]"
                                ></v-checkbox>
                                <v-file-input outlined rounded prepend-icon="fa-paperclip" hide-details="auto" class="mb-4"
                                    label="Toestemmingsverklaring" v-model="profile.consentDeclaration" :rules="[requiredRule]"
                                ></v-file-input>
                                <v-radio-group v-model="acceptTerms" :rules="[acceptTermsRule]" class="mb-4">
                                    <template v-slot:label>
                                        <div>Passie voor Onderwijs is ingericht om scholen en professionals met elkaar in contact te brengen. Om jouw profiel zichtbaar te maken voor schoolbesturen, hebben we je jouw toestemming nodig.<br />
                                            <strong>Ik geef toestemming voor het delen van mijn gegevens met schoolbesturen die gebruikmaken van Passie voor Onderwijs.</strong></div>
                                    </template>
                                    <v-radio :value="true">
                                        <template v-slot:label>
                                            <div>Ja</div>
                                        </template>
                                    </v-radio>
                                    <v-radio :value="false">
                                        <template v-slot:label>
                                            <div>Nee</div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                                <RegisterProfileDialog class="mb-2 elevation-0" :submitting="submitting" :loading="loading" @submit="submit"></RegisterProfileDialog>
                            </div>
                            <v-alert v-else color="success">Het profiel is succesvol opgestuurd, er wordt zo spoedig mogelijk contact met je opgenomen.</v-alert>
                            <v-btn :to="{name: 'SignIn'}" block outlined rounded color="secondary" class="elevation-0">Terug naar inloggen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";
import apiClient from "@/api/apiClient";
import {mapState} from "vuex";
import RegisterProfileDialog from "@/components/profile/RegisterProfileDialog.vue";

const youtubeRegex = /(https?:\/\/)?(www.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})[?]?.*/;
const vimeoRegex = /(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
const phoneNumberRegex = /^\(?([+]31|0031|0)(\s?|-)([0-9]\s{0,3}){9}$/g;
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "RegisterProfile",
    components: {
        Headful,
        Header,
        RegisterProfileDialog,
    },
    data: () => ({
        submitting: false,
        submitted: false,
        loading: true,
        success: false,
        acceptTerms: null,
        profile: {
            name: null,
            dateOfBirth: null,
            city: null,
            phoneNumber: null,
            email: null,
            introduction: null,
            summary: null,
            remarks: null,
            videoUrl: null,
            image: null,
            curriculumVitae: null,
            consent: false,
            consentDeclaration: null,
            facetChoices: {},
            facetRemark: null,
        },
        requiredRule: (value) => !!value || "Dit veld is verplicht.",
        videoUrlRule: (value) => (!value || (!!value && (value.match(youtubeRegex) || value.match(vimeoRegex)))) || "Ongeldige YouTube of Vimeo URL.",
        phoneNumberRule: (value) => (!value || (!!value && value.match(phoneNumberRegex))) || "Ongeldig telefoonnummer, gebruik 10 cijfers zonder spaties.",
        emailRule: (value) => (!value || (!!value && value.match(emailRegex))) || "Ongeldig e-mailadres.",
        consentRule: (value) => !!value || "Toestemming voor opname van persoonsgegevens is verplicht.",
        acceptTermsRule: (value) => !!value || "Het profiel kan niet ingestuurd worden zonder toestemming.",
    }),
    computed: {
        notEmptyRule () {
            return (value) => (!this.submitted || value.length > 0) || "Dit veld is verplicht.";
        },
        ...mapState({
            facets: state => state.profile.facets,
        }),
    },
    created() {
        this.$store.dispatch('updateFacets')
            .then(() => {
                this.facets.forEach(facet => {
                    this.profile.facetChoices['facet'+facet.id] = [];
                });
                this.loading = false;
            })
            .catch(() => {
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Er kon niet met de server worden verbonden, controleer je verbinding' });
            })
    },
    methods: {
        submit () {
            this.submitted = true;

            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitting || this.loading) {
                return;
            }

            this.submitting = true;

            const formData = new FormData();
            Object.keys(this.profile).forEach(key => {
                if (key === 'consent') {
                    formData.append(key, this.profile[key] ? '1' : '0');
                } else if (this.profile[key]) {
                    formData.append(key, key === 'facetChoices' ? JSON.stringify(this.profile[key]) : this.profile[key]);
                }
            });

            // Submit profile
            apiClient.post('/profielen/nieuw', formData).then(() => {
                // Success
                this.success = true;
                this.$router.push({name: 'RegisterSuccess'})
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Ongeldige gegevens, controleer de invoer' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
